var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.state && _vm.showClear
    ? _c("li", { staticClass: "margin-bottom-2xs margin-right-sm" }, [
        _c(
          "button",
          {
            staticClass:
              "icon-facet-pill icon-facet-pill-clear tag flat rounded",
            staticStyle: {
              "--tag-background": "transparent",
              "--button-margin-bottom": "0",
              "--button-hover-color": "var(--fa-dk-blue)",
              "--button-active-color": "var(--fa-dk-blue)",
              "--button-hover-background": "transparent",
              "--button-active-background": "transparent",
              "--button-active-border-width": "var(--border-width-sm)",
              "--link-decoration-style": "none",
              "--link-decoration-line": "none",
              "--link-hover-decoration-style": "none",
              "--link-hover-decoration-line": "none",
              "--tag-padding": "var(--spacing-sm) var(--spacing-md)",
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.clearSearch()
              },
            },
          },
          [
            _vm._v("\n    Reset\n    "),
            _c("span", { staticClass: "sr-only" }, [
              _vm._v("All Filters + Queries"),
            ]),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }